import React from "react";
import logo from "assets/logos/iserba.png";

const BackgroundIserba = () => {
	return (
		<div
			className="relative flex h-full w-full opacity-10  pointer-events-none border-red-500 bg-yellow-100/50 border-2"
			style={{
				backgroundImage: `url(${logo})`,
				backgroundRepeat: "repeat",
				backgroundSize: "262px 144px", // Increased spacing
				padding: "20px 20px",
				filter: "contrast(0) brightness(0)",
				height: "calc(var(--vh, 1vh) * 100)",
				paddingTop: "env(safe-area-inset-top)",
				paddingBottom: "env(safe-area-inset-bottom)",
			}}
		/>
	);
};

export default BackgroundIserba;
